import { useState, useEffect } from 'react';
import {ApiUrl} from "../../ApiUrl"
const useBookCategories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchCategories = async () => {
        setLoading(true); // Set loading to true before fetching
        try {
            const response = await fetch(`${ApiUrl.apiurl}BookCategory/GetAllBookCategoryList/`);
            const result = await response.json();
            if (response.ok) {
                setCategories(Array.isArray(result?.data) ? result.data : []);
            } else {
                setError(result.message); // Handle error message from API
            }
        } catch (err) {
            setError('Error fetching categories: ' + err.message);
            setCategories([]);
        } finally {
            setLoading(false); // Set loading to false after fetching
        }
    };
    useEffect(() => {
        fetchCategories();
    }, []);
    return { categories, loading, error, fetchCategories }; // Return fetchCategories
};
export default useBookCategories;